
import img1 from '../assets/img/avatar.png'
import dfIMG from '../assets/images/img-upload.png'
import { toast } from 'react-toastify';
var CryptoJS = require('crypto-js');
export const defaultUserIMG = img1
export const defaultIMG = dfIMG

export const IS_LIVE = true

//invoice
export const imgBaseURL1 = () => {
    return IS_LIVE ? "https://sales.itworkshop.in/" : "https://invoice.itworkshop.in/";
}

export const invoiceBaseURL = () => {
    
    return IS_LIVE ? "https://sales.itworkshop.in/" : "https://invoice.itworkshop.in/";
}



export const apiVersion = () => {   
    return "/v1/"
}
export const encryptId = (id) => {
    const encrypted = CryptoJS.AES.encrypt(id, "MYID").toString();
    return encrypted;
};

export const decryptId = (encryptedId) => {
    const bytes = CryptoJS.AES.decrypt(encryptedId, "MYID");
    const originalId = bytes.toString(CryptoJS.enc.Utf8);
    return originalId;
};

export const filterByKey = (key, obj) => {
    if (auth('admin')?.user_role === 'admin') {
        const data = { edit: true, read: true, delete: true, create: true }
        return data
    } else {
        if (!obj || typeof obj !== 'object') {
            return null;
        }
        return obj.hasOwnProperty(key) ? obj[key] : null;
    }
};

export const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export const formatdedDate = (date) => {
    if (!(date instanceof Date)) {
        const parsedDate = new Date(date);
        if (isNaN(parsedDate.getTime())) {
            return '';
        }
        date = parsedDate;
    }

    const formattedDate = date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });

    const formattedTime = date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
    const formattedDateTime = `${formattedDate} ${formattedTime}`;
    return formattedDateTime;
}

export const encryptSessionStorageData = (name, data, key) => {
    var encryptData = CryptoJS.AES.encrypt(JSON.stringify(data), key).toString();
    sessionStorage.setItem(name, encryptData)
}

export const dycryptSessionStorageData = (encryptData, key) => {
    var bytes = CryptoJS.AES.decrypt(encryptData, key);
    var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData
}

export const authUser = () => {
    if (sessionStorage.getItem('web-secret')) {
        return dycryptSessionStorageData(sessionStorage.getItem('web-secret'), "DoNotTryToAccess")
    } else {
        return null
    }
}

export const encryptLocalStorageData = (name, data, key) => {
    var encryptData = CryptoJS.AES.encrypt(JSON.stringify(data), key).toString();
    sessionStorage.setItem(name, encryptData)
}

export const dycryptLocalStorageData = (encryptData, key) => {
    var bytes = CryptoJS.AES.decrypt(encryptData, key);
    var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData
}

export const getTokenType = (type) => {
    if (type === 'admin') return 'admin-secret';
    if (type === 'hr')    return 'admin-secret'; // ← HR also stored under same key
    if (type === 'salesperson') return 'salesperson-secret';
    return 'admin-secret'; // safe default
}

export const auth = (type) => {
    const key = getTokenType(type);
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;

    try {
        const data = dycryptLocalStorageData(raw, "DoNotTryToAccess");
        if (!data?.token) return null;

        // Check JWT expiry without any library
        const payload = JSON.parse(atob(data.token.split('.')[1]));
        if (payload.exp * 1000 < Date.now()) {
            // Token expired — clear it so user must login again
            sessionStorage.removeItem(key);
            return null;
        }

        return data;
    } catch (e) {
        sessionStorage.removeItem(key);
        return null;
    }
}

export const generateSlug = (str) => {
    return str.toLowerCase().replace(/[\s_]/g, '-').replace(/[^\w-]+/g, '');
};

export const toastifySuccess = (message) => {
    toast.success(`${message}`, {
        position: 'top-right',
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
    });
};

export const toastifyError = (message) => {
    toast.error(`${message}`, {
        position: 'top-right',
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
    });
};


export const getRootURL = (role) => {
    const getRole = role ? role : auth('admin')?.user_role;
    return getRole;
};

export const textFormated = (text) => {
    const words = text.split('-');
    const formattedText = words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    return formattedText;
};

export const stringToArray = (str) => {
    if (!str) return [];
    const stringArray = str.split(',');
    const numberArray = stringArray.map((item) => {
        const parsed = parseInt(item.trim(), 10);
        return isNaN(parsed) ? null : parsed;
    });
    return numberArray.filter(item => item !== null);
};

export const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
};

const MONTH_NAMES = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
];


function getFormattedDate(date, prefomattedDate = false, hideYear = false) {
    const day = date.getDate();
    const month = MONTH_NAMES[date.getMonth()];
    const year = date.getFullYear();
    const hours = date.getHours();
    let minutes = date.getMinutes();

    if (minutes < 10) {
        // Adding leading zero to minutes
        minutes = `0${minutes}`;
    }
    if (prefomattedDate) {
        // Today at 10:20
        // Yesterday at 10:20
        return `${prefomattedDate} at ${hours}:${minutes}`;
    }
    if (hideYear) {
        // 10. January at 10:20
        return `${day} ${month} at ${hours}:${minutes}`;
    }
    // 10. January 2017. at 10:20
    return `${day} ${month} ${year} at ${hours}:${minutes}`;
}


// --- Main function
export function timeAgo(dateParam) {
    if (!dateParam) {
        return null;
    }
    const date = typeof dateParam === 'object' ? dateParam : new Date(dateParam);
    const DAY_IN_MS = 86400000; // 24 * 60 * 60 * 1000
    const today = new Date();
    const yesterday = new Date(today - DAY_IN_MS);
    const seconds = Math.round((today - date) / 1000);
    const minutes = Math.round(seconds / 60);
    const isToday = today.toDateString() === date.toDateString();
    const isYesterday = yesterday.toDateString() === date.toDateString();
    const isThisYear = today.getFullYear() === date.getFullYear();


    if (seconds < 5) {
        return 'just now';
    } else if (seconds < 60) {
        return `${seconds} seconds ago`;
    } else if (seconds < 90) {
        return 'about a minute ago';
    } else if (minutes < 60) {
        return `${minutes} minutes ago`;
    } else if (isToday) {
        return getFormattedDate(date, 'Today'); // Today at 10:20
    } else if (isYesterday) {
        return getFormattedDate(date, 'Yesterday'); // Yesterday at 10:20
    } else if (isThisYear) {
        return getFormattedDate(date, false, false); // 10. January at 10:20
    }

    return getFormattedDate(date); // 10. January 2017. at 10:20
}


export const tableImg = (img) => {
    return (
        <>
            {
                img &&
                <img src={imgBaseURL1() + img} alt="" style={{ height: "45px", width: '45px', borderRadius: '100%' }} />
            }
        </>
    )
}

